import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import MiniCart from '../MiniCart';
import MobileNav from '../../nav/MobileNav';

const HeaderUtils = ({ ctx, node }) => {
  const position = useRef(null)
  position.current = node.dataset.position

  var data = null;
  try {
    data = JSON.parse(document.querySelector('script[data-header-utils-data]')?.innerHTML);
    window.theme_app.hydrate({
      show_free_shipping_threshold: data.show_free_shipping_threshold,
      free_shipping_threshold: data.free_shipping_threshold,
      free_shipping_exclude_types: data.free_shipping_exclude_types
    });
  } catch (error) {
    console.error(error);
  }

  return (
    <>
      {position.current == 'left'
        ? <MobileNav />
        : <MiniCart />
      }
    </>
  );
};

export default component((node, ctx) => {
  const element = <HeaderUtils ctx={ctx} node={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
